import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-fintech-solutions-icons',
  templateUrl: './fintech-solutions-icons.component.html',
  styleUrls: ['./fintech-solutions-icons.component.css']
})
export class FintechSolutionsIconsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/components/fintech-solutions/fintech-solutions-icons/fintech-solutions-icons.component.ts